import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "component/UseAuth";
import Logo_GH from "assets/images/logo_GH.png";

const Sidebar = () => {
  const { user, access } = useAuth();
  const location = useLocation();

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [openMainMenu, setOpenMainMenu] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);

  const canAccess = (menuName) => {
    if (!access || access.length === 0) return false;

    // Cocokkan case-insensitive dengan menu_desc dari backend
    return access.some(
      (item) => item.menu_desc?.toLowerCase() === menuName.toLowerCase()
    );
  };

  const isBookingPage = ["/booking-pending", "/booking-accepted", "/booking-canceled"].includes(location.pathname);
  const isTransaksiPage = ["/jurnal-umum", "/jurnal-pendapatan", "/jurnal-biaya"].includes(location.pathname);
  const isReportPage = ["/report-chart-of-account", "/neraca", "/detail-neraca",
                        "/laba-rugi", "/detail-laba-rugi", "/cash-flow", "/kas-rekening", 
                        "/general-ledger", "/summary-jurnal",].includes(location.pathname);
  const isMasterPage = ["/closing-laba-rugi", "/pindah-bulan", "/group-account",
                        "/master-chart-account", "/chart-of-account-master"].includes(location.pathname);

  // Auto open menu on route change
  useEffect(() => {
    const dashboardRoutes = ["/analytics", "/calendar"];
    const masterRoutes = ["/user", "/menu", "/access", "/bank", "/category", "/item", "/feature", "/room"];
    const hrdRoutes = ["/employee", "/absensi"];
    const bookingRoutes = [ "/booking-pending", "/booking-accepted", "/booking-canceled", "/new-booking"];
    const akuntingRoutes = [
    "/jurnal-umum", "/jurnal-pendapatan", "/jurnal-biaya",
    "/report-chart-of-account", "/neraca", "/detail-neraca",
    "/laba-rugi", "/detail-laba-rugi", "/cash-flow",
    "/general-ledger", "/summary-jurnal", "/kas-rekening",
    "/closing-laba-rugi", "/pindah-bulan", "/group-account",
    "/master-chart-account", "/chart-of-account-master"
    ];

    if (bookingRoutes.includes(location.pathname)) {
      setOpenMainMenu("booking");

      // Khusus untuk All Booking (yang punya submenu)
      if (
        ["/booking-pending", "/booking-accepted", "/booking-canceled"].includes(
          location.pathname
        )
      ) {
        setOpenSubMenu("booking-status");
      } else {
        setOpenSubMenu(null); // jangan tampilkan submenu
      }
    } else if (akuntingRoutes.includes(location.pathname)) {
      setOpenMainMenu("akunting");

      if (["/jurnal-umum","/jurnal-pendapatan","/jurnal-biaya"].includes(location.pathname)) {
        setOpenSubMenu("akunting-transaksi");
      } else if (
        [
          "/report-chart-of-account", "/neraca", "/detail-neraca",
          "/laba-rugi", "/detail-laba-rugi", "/cash-flow",
          "/general-ledger", "/summary-jurnal", "/kas-rekening",
        ].includes(location.pathname)
      ) {
        setOpenSubMenu("akunting-report");
      } else {
        setOpenSubMenu("akunting-master");
      }
    } else if (dashboardRoutes.includes(location.pathname)) {
      setOpenMainMenu("dashboard");
      setOpenSubMenu(null);
    } else if (masterRoutes.includes(location.pathname)) {
      setOpenMainMenu("master");
      setOpenSubMenu(null);
    } else if (hrdRoutes.includes(location.pathname)) {
      setOpenMainMenu("hrd");
      setOpenSubMenu(null);
    }else if (akuntingRoutes.includes(location.pathname)) {
      setOpenMainMenu("akunting");
      setOpenSubMenu(null);
    } else {
      setOpenMainMenu(null);
      setOpenSubMenu(null);
    }
  }, [location.pathname]);

  const toggleMainMenu = (menuName) => {
    if (isCollapsed) {
      setIsCollapsed(false);
    }
    setOpenMainMenu(openMainMenu === menuName ? null : menuName);
  };

  const toggleSubMenu = (subMenuName) => {
    setOpenSubMenu(openSubMenu === subMenuName ? null : subMenuName);
  };

  return (
    <aside
      id="layout-menu"
      className={`layout-menu menu-vertical menu bg-menu-theme ${isCollapsed ? "collapsed" : ""}`}
    >
      {/* Logo & Toggle Button */}
      <div className={`app-brand ${isCollapsed ? "mb-5" : "mb-2"}`}>
        <a href="/dashboard" className="app-brand-link text-decoration-none mt-3">
          {!isCollapsed && <img src={Logo_GH} height="80" alt="logo-gh" />}
        </a>
        <button
          className="toggle-sidebar-btn ms-auto"
          onClick={() => {
            setIsCollapsed(!isCollapsed);
          }}
        >
          <i className={`bx ${isCollapsed ? "bx-chevron-right" : "bx-chevron-left"} bx-sm align-middle`}></i>
        </button>
      </div>

      <div className="menu-inner-shadow"></div>

      {/* Menu Items */}
      <ul className="menu-inner py-1 mb-5">
        
        {/* Dashboard */}
        <>
          {( canAccess("analytics") || canAccess("calendar")) && (
          <li
            className="menu-header small text-uppercase"
            onClick={() => toggleMainMenu("dashboard")}
            style={{ cursor: isCollapsed ? "default" : "pointer" }}
          >
            {!isCollapsed && (
              <span className="menu-header-text d-flex justify-content-between align-items-center">
                Dashboard
                <i className={`bx bx-chevron-${openMainMenu === "dashboard" ? "down" : "right"} ms-auto`}></i>
              </span>
            )}
          </li>
          )}
          
          {(isCollapsed || openMainMenu === "dashboard") && (
            <>
              {[
                { path: "/calendar", label: "Calendar", icon: "bx bx-calendar", access: "calendar" },
                { path: "/analytics", label: "Analytics", icon: "bx bx-bar-chart-alt-2", access: "analytics" },
              ]
                .filter((item) => canAccess(item.access))
                .map((item) => (
                <li
                    className={`menu-item ${location.pathname === item.path ? "active" : ""}`}
                    key={item.path}
                  >
                    <a href={item.path} className="menu-link text-decoration-none">
                      <i className={`menu-icon tf-icons bx ${item.icon}`}></i>
                      {!isCollapsed && <div>{item.label}</div>}
                    </a>
                </li>
              ))}
            </>
          )}
        </>
        {/* {canAccess("dashboard") && (
          <li className={`menu-item ${location.pathname === "/dashboard" ? "active" : ""}`}>
            <a href="/dashboard" className="menu-link text-decoration-none">
              <i className="menu-icon tf-icons bx bx-home-circle"></i>
              {!isCollapsed && <div>Dashboard</div>}
            </a>
          </li>
        )} */}

        {/* MASTER */}
        <>
          {( canAccess("user") || canAccess("menu") || canAccess("access") || canAccess("bank")
          || canAccess("category") || canAccess("item") || canAccess("feature")) && (
          <li
            className="menu-header small text-uppercase"
            onClick={() => toggleMainMenu("master")}
            style={{ cursor: isCollapsed ? "default" : "pointer" }}
          >
            {!isCollapsed && (
              <span className="menu-header-text d-flex justify-content-between align-items-center">
                Master
                <i className={`bx bx-chevron-${openMainMenu === "master" ? "down" : "right"} ms-auto`}></i>
              </span>
            )}
          </li>
          )}

          {(isCollapsed || openMainMenu === "master") && (
            <>
              {[
                { path: "/user", label: "User", icon: "bx-user-circle", access: "user" },
                { path: "/menu", label: "Menu", icon: "bx-menu", access: "menu" },
                { path: "/access", label: "Access", icon: "bx-lock-alt", access: "access" },
                { path: "/bank", label: "Bank", icon: "bx-credit-card-front", access: "bank" },
                { path: "/category", label: "Category", icon: "bx-category", access: "category" },
                { path: "/item", label: "Item", icon: "bx-spreadsheet", access: "item" },
                { path: "/feature", label: "Feature", icon: "bx-globe-alt", access: "feature" },
                { path: "/room", label: "Room", icon: "bx-bed", access: "room" },
              ]
                .filter((item) => canAccess(item.access))
                .map((item) => (
                  <li
                    className={`menu-item ${location.pathname === item.path ? "active" : ""}`}
                    key={item.path}
                  >
                    <a href={item.path} className="menu-link text-decoration-none">
                      <i className={`menu-icon tf-icons bx ${item.icon}`}></i>
                      {!isCollapsed && <div>{item.label}</div>}
                    </a>
                  </li>
                ))}
            </>
          )}
        </>

        {/* HRD */}
        <>
          {( canAccess("karyawan") || canAccess("absensi")) && (
          <li
            className="menu-header small text-uppercase"
            onClick={() => toggleMainMenu("hrd")}
            style={{ cursor: isCollapsed ? "default" : "pointer" }}
          >
            {!isCollapsed && (
              <span className="menu-header-text d-flex justify-content-between align-items-center">
                HRD
                <i className={`bx bx-chevron-${openMainMenu === "hrd" ? "down" : "right"} ms-auto`}></i>
              </span>
            )}
          </li>
          )}
          
          {(isCollapsed || openMainMenu === "hrd") && (
            <>
              {[
                { path: "/employee", label: "Karyawan", icon: "bx-user-circle", access: "karyawan" },
                { path: "/absensi", label: "Absensi", icon: "bx-check-circle", access: "absensi" },
              ]
                .filter((item) => canAccess(item.access))
                .map((item) => (
                <li
                    className={`menu-item ${location.pathname === item.path ? "active" : ""}`}
                    key={item.path}
                  >
                    <a href={item.path} className="menu-link text-decoration-none">
                      <i className={`menu-icon tf-icons bx ${item.icon}`}></i>
                      {!isCollapsed && <div>{item.label}</div>}
                    </a>
                </li>
              ))}
            </>
          )}
        </>

        {/* BOOKING */}
          <>
            {/* Booking Header */}
            {( canAccess("pending") || canAccess("accepted") || canAccess("canceled") || canAccess("new Booking")) && (
            <li
              className="menu-header small text-uppercase"
              onClick={() => !isCollapsed && toggleMainMenu("booking")}
              style={{ cursor: isCollapsed ? "default" : "pointer" }}
            >
              {!isCollapsed && (
                <span className="menu-header-text d-flex justify-content-between align-items-center">
                  Booking
                  <i className={`bx bx-chevron-${openMainMenu === "booking" ? "down" : "right"} ms-auto`}></i>
                </span>
              )}
            </li>
            )}
            {/* Booking Content */}
            {(isCollapsed || openMainMenu === "booking") && (
              <>
                {/* All Booking Section */}
                <li
                  className={`menu-item ${isBookingPage ? "active" : ""} ${
                    openSubMenu === "booking-status" && !isCollapsed ? "open" : ""
                  }`}
                >
                  {( canAccess("pending") || canAccess("accepted") || canAccess("canceled") ) && (
                  <a
                    href={isCollapsed ? "/booking-pending" : "#"}
                    onClick={(e) => {
                      if (!isCollapsed) {
                        e.preventDefault();
                        toggleSubMenu("booking-status");
                      }
                    }}
                    className={`menu-link text-decoration-none ${!isCollapsed ? "menu-toggle" : ""}`}
                  >
                    <i className="menu-icon tf-icons bx bx-spreadsheet"></i>
                    <div>All Booking</div>
                  </a>
                  )}

                  {!isCollapsed && openSubMenu === "booking-status" && (
                    <ul className="menu-sub" style={{ display: "block" }}>
                    <>
                      {[
                        { path: "/booking-pending", label: "Pending", access: "pending" },
                        { path: "/booking-accepted", label: "Accepted", access: "accepted" },
                        { path: "/booking-canceled", label: "Canceled", access: "canceled" },
                      ]
                        .filter((item) => canAccess(item.access))
                        .map((item) => (
                          <li
                            className={`menu-item ${location.pathname === item.path ? "active" : ""}`}
                            key={item.path}
                          >
                            <a href={item.path} className="menu-link text-decoration-none">
                              <div>{item.label}</div>
                            </a>
                          </li>
                        ))}
                    </>
                    </ul>
                  )}
                </li>

                {canAccess("new Booking") && (
                  <li className={`menu-item ${location.pathname.startsWith("/new-booking") ? "active" : ""}`}>
                    <a href="/new-booking" className="menu-link text-decoration-none">
                      <i className="menu-icon tf-icons bx bx-basket"></i>
                      <div>New Booking</div>
                    </a>
                  </li>
                )}
              </>
            )}
          </>

        {/* Akunting */}
        <>
          {( canAccess("Jurnal Umum") || canAccess("Jurnal Pendapatan") || canAccess("Jurnal Biaya") 
          || canAccess("Report CoA") || canAccess("Neraca") || canAccess("Detail Neraca") 
          || canAccess("Laba Rugi") || canAccess("Detail Laba Rugi") || canAccess("Kas Rekening")
          || canAccess("Cash FLow") || canAccess("General Ledger") || canAccess("Summary Jurnal")
          || canAccess("Closing Laba Rugi") || canAccess("Pindah Bulan") || canAccess("Group Account")
          || canAccess("Master Chart Account") || canAccess("Chart Of Account")) && (
          <li
            className="menu-header small text-uppercase"
            onClick={() => !isCollapsed && toggleMainMenu("akunting")}
            style={{ cursor: isCollapsed ? "default" : "pointer" }}
          >
            {!isCollapsed && (
              <span className="menu-header-text d-flex justify-content-between align-items-center">
                Akunting
                <i className={`bx bx-chevron-${openMainMenu === "akunting" ? "down" : "right"} ms-auto`}></i>
              </span>
            )}
          </li>
          )}

          {(isCollapsed || openMainMenu === "akunting") && (
            <>
            <li 
              className={`menu-item ${isTransaksiPage ? "active" : ""} ${
              openSubMenu === "akunting-transaksi" && !isCollapsed ? "open" : ""
              }`}
            >
              {( canAccess("Jurnal Umum") || canAccess("Jurnal Pendapatan") || canAccess("Jurnal Biaya")) && (
              <a
                href={isCollapsed ? "/jurnal-umum" : "#"}
                onClick={(e) => {
                  if (!isCollapsed) {
                    e.preventDefault();
                    toggleSubMenu("akunting-transaksi");
                  }
                }}
                className={`menu-link text-decoration-none ${!isCollapsed ? "menu-toggle" : ""}`}
              >
                <i className="menu-icon tf-icons bx bx-transfer-alt"></i>
                <div>Transaksi</div>
              </a>
              )}

              {!isCollapsed && openSubMenu === "akunting-transaksi" && (
                <ul className="menu-sub" style={{ display: "block" }}>
                  {[
                    { path: "/jurnal-umum", label: "Jurnal Umum", access: "Jurnal Umum" },
                    { path: "/jurnal-pendapatan", label: "Jurnal Pendapatan", access: "Jurnal Pendapatan" },
                    { path: "/jurnal-biaya", label: "Jurnal Biaya", access: "Jurnal Biaya" },
                  ]
                    .filter((item) => canAccess(item.access))
                    .map((item) => (
                    <li className={`menu-item ${location.pathname === item.path ? "active" : ""}`} key={item.path}>
                      <a href={item.path} className="menu-link text-decoration-none">
                        <div>{item.label}</div>
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            
            <li 
              className={`menu-item ${isReportPage ? "active" : ""} ${
              openSubMenu === "akunting-report" && !isCollapsed ? "open" : ""
              }`}
            >
              {( canAccess("Report CoA") || canAccess("Neraca") || canAccess("Detail Neraca") 
              || canAccess("Laba Rugi") || canAccess("Detail Laba Rugi") || canAccess("Kas Rekening")
              || canAccess("Cash FLow") || canAccess("General Ledger") || canAccess("Summary Jurnal")) && (
              <a
                href={isCollapsed ? "/report-chart-of-account" : "#"}
                onClick={(e) => {
                  if (!isCollapsed) {
                    e.preventDefault();
                    toggleSubMenu("akunting-report");
                  }
                }}
                className={`menu-link text-decoration-none ${!isCollapsed ? "menu-toggle" : ""}`}
              >
                <i className="menu-icon tf-icons bx bx-bar-chart-square"></i>
                <div>Report</div>
              </a>
              )}

              {!isCollapsed && openSubMenu === "akunting-report" && (
                <ul className="menu-sub" style={{ display: "block" }}>
                  {[
                    { path: "/report-chart-of-account", label: "Chart of Account", access: "Report CoA" },
                    { path: "/neraca", label: "Neraca", access: "Neraca" },
                    { path: "/detail-neraca", label: "Detail Neraca", access: "Detail Neraca" },
                    { path: "/laba-rugi", label: "Laba Rugi", access: "Laba Rugi" },
                    { path: "/detail-laba-rugi", label: "Detail Laba Rugi", access: "Detail Laba Rugi" },
                    { path: "/kas-rekening", label: "KAS Rekening", access: "KAS Rekening" },
                    { path: "/cash-flow", label: "Cash Flow", access: "Cash Flow" },
                    { path: "/general-ledger", label: "General Ledger", access: "General Ledger" },
                    { path: "/summary-jurnal", label: "Summary Jurnal", access: "Summary Jurnal" },
                  ]
                    .filter((item) => canAccess(item.access))
                    .map((item) => (
                    <li className={`menu-item ${location.pathname === item.path ? "active" : ""}`} key={item.path}>
                      <a href={item.path} className="menu-link text-decoration-none">
                        <div>{item.label}</div>
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            
            <li 
              className={`menu-item ${isMasterPage ? "active" : ""} ${
              openSubMenu === "akunting-master" && !isCollapsed ? "open" : ""
              }`}
            >
              {( canAccess("Closing Laba Rugi") || canAccess("Pindah Bulan") || canAccess("Group Account")
              || canAccess("Master Chart Account") || canAccess("Chart Of Account")) && (
              <a
                href={isCollapsed ? "/closing-laba-rugi" : "#"}
                onClick={(e) => {
                  if (!isCollapsed) {
                    e.preventDefault();
                    toggleSubMenu("akunting-master");
                  }
                }}
                className={`menu-link text-decoration-none ${!isCollapsed ? "menu-toggle" : ""}`}
              >
                <i className="menu-icon tf-icons bx bx-cog"></i>
                <div>Master</div>
              </a>
              )}

              {!isCollapsed && openSubMenu === "akunting-master" && (
                <ul className="menu-sub" style={{ display: "block" }}>
                  {[
                    { path: "/closing-laba-rugi", label: "Closing Laba Rugi", access: "Closing Laba Rugi" },
                    { path: "/pindah-bulan", label: "Pindah Bulan", access: "Pindah Bulan" },
                    { path: "/group-account", label: "Group Account", access: "Group Account" },
                    { path: "/master-chart-account", label: "Master Chart Account", access: "Master Chart Account" },
                    { path: "/chart-of-account-master", label: "Chart of Account", access: "Chart of Account" },
                  ]
                    .filter((item) => canAccess(item.access))
                    .map((item) => (
                    <li className={`menu-item ${location.pathname === item.path ? "active" : ""}`} key={item.path}>
                      <a href={item.path} className="menu-link text-decoration-none">
                        <div>{item.label}</div>
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            </>
          )}
        </>

      </ul>
    </aside>
  );
};

export default Sidebar;
